import { commonRegx } from "xcommon-node/src/common/commonRegx";
import { EntitySupplier } from "../../entity/EntitySupplier";

export class DtoSuppliersGetRes extends EntitySupplier {
  public items: EntitySupplier[]  = [];
}
